export default __webpack_public_path__ + "static/media/Savant's Belt of the Waning Moon.62ea9034.jpg";